export default __webpack_public_path__ + "static/media/BackgroundKahshStoreWeb.6bcc922b.png";